import React from 'react'
import { Grid } from '@mui/material'
import Card from '../../shared/layout/Card'
import MySummaryEntitlementSplit from '../../shared/UI/MySummaryEntitlementSplit/MySummaryEntitlementSplit'
import NoDataFound from '../../shared/UI/NoDataFound'
import LoadingIndicator from '../../shared/UI/LoadingIndicator'
import { EntitlementSplit } from '../../types/entitlement-split'

interface SummaryCardProps {
  entitlementSplit: EntitlementSplit | undefined
  isLoading: boolean
}

const SummaryCard: React.FC<SummaryCardProps> = function ({ entitlementSplit, isLoading }) {
  return (
    <Card title="Summary">
      {entitlementSplit ? (
        <Grid container spacing={4}>
          <Grid item xs={12}>
            <MySummaryEntitlementSplit
              marginTop={0}
              marginBottom={0}
              titleMarginBottom={1}
              summaryItems={entitlementSplit}
            />
          </Grid>
        </Grid>
      ) : (
        <>
          <NoDataFound show={!isLoading} />
          <LoadingIndicator show={isLoading} />
        </>
      )}
    </Card>
  )
}

export default SummaryCard